import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByRefreshTokenInterceptor = new HttpContextToken(() => true);

export const isSkippedByRefreshToken = <Body>(
  request: HttpRequest<Body>
): boolean => {
  return request.context.has(SkipByRefreshTokenInterceptor);
};
